const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { ComparativeBarComposed } = require('commonsComponents/comparativeBarComposed');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKLink } = require('commonsComponents/OKLink');
// @ actions
const progressBarActions = require('actions/mortgageRequest/mortgageRequestProgressBar');

class ProgressBar extends React.Component {
    constructor(props) {
        super(props);

        this.progress = 10;
    }

    componentDidMount() {
        const { mortgageRequestState, calculateProgress } = this.props;
        calculateProgress(mortgageRequestState.get('estado'));
    }

    render() {
        const {
            mortgageRequestProgressBar,
            progressState,
            onHandleToggleCalendar,
            isLoadingTargetDate,
            currentState
        } = this.props;

        if (mortgageRequestProgressBar.get('progress')) {
            this.progress = mortgageRequestProgressBar.get('progress');
        }

        let textLink = (
            <OKLink
                inverse="true"
                modifier="complementary"
                onClick={onHandleToggleCalendar}
            >
                <FormattedText value="mortgageRequestPanel-progressBarLink" />
            </OKLink>
        );
        if (isLoadingTargetDate) {
            textLink = <p className="mortgage-request-target-date-bar__white">{formatText('mortgageRequestPanel-updatingText')}</p>;
        }

        let toolTip = '';

        if (currentState === 'preApproved') {
            toolTip = (
                <OKTooltip
                    content="mortgageRequestPanel-headerTooltip"
                    modifier="dark-bg"
                    offset={[0, -15]}
                />
            );
        }

        return (
            <div>
                <p className="mortgage-request-target-date-bar__text2">
                    {formatText('mortgageRequestPanel-state')} <strong className="mortgage-request-target-date-bar__space-tooltip">{progressState}</strong>
                    {toolTip}
                    <span className="pull-right">
                        {this.progress}%
                    </span>
                </p>
                <ComparativeBarComposed
                    firstValue={this.progress}
                    secondValue={100 - this.progress}
                    totalValue={100}
                    firstColor="#FCB900"
                    secondColor="#B2C0CB"
                    height={5}
                />
                {textLink}
            </div>
        );
    }
}

ProgressBar.propTypes = {
    currentState: PropTypes.string,
    progressState: PropTypes.string,
    onHandleToggleCalendar: PropTypes.func,
    mortgageRequestProgressBar: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    calculateProgress: PropTypes.func,
    isLoadingTargetDate: PropTypes.bool
};

ProgressBar.defaultProps = {
    progressState: '-'
};

module.exports.constructor = ProgressBar;
module.exports.ProgressBar = connect(state => ({
    mortgageRequestProgressBar: state.mortgageRequestProgressBar,
    mortgageRequestState: state.mortgageRequestState
}), {
        calculateProgress: progressBarActions.calculateProgress
    })(ProgressBar);
